<template>
    <card class="clickable" :class="bgCssClass" style="min-height: 350px;" @click="openModal" @mouseenter="onMouseEnter" @mouseleave="onMouseLeave">
        <div class="my-auto">
            <card-body class="my-auto text-center">
                <div style="width:42px; height:42px;" class="mx-auto mb-3 text-primary">
                    <marquis-circle-icon />
                </div>

                <h5>
                    Prefer a more <em>personalized approach?</em>
                </h5>

                <div class="small mb-3">Our Travel Specialist team will send you available properties that best meet your search parameters.</div>

                <div class="mb-3">
                    <ui-button size="sm">Click Here</ui-button>
                </div>

                <propety-inquire-modal v-if="showModal" :open="modalOpen" @close="closeModal" :checkIn="checkIn" :checkOut="checkOut" :numAdults="adults" :numChildren="children" :inquireType="inquireType"/>
            </card-body>
        </div>
        
    </card>
</template>

<script type="text/javascript">
    import PropetyInquireModal from '@/components/Content/Public/Properties/InquireModal.vue';
    import CommonComponents from '@/components/Common.vue';
    import DateObject from '@/classes/DateObject.js';

    import MarquisCircleIcon from '@/assets/logos/marquis-circle-icon.svg.vue';

    export default {
        components: {
            MarquisCircleIcon,
            PropetyInquireModal,
            ...CommonComponents,
        },

        data() {
            return {
                showModal: false,
                modalOpen: true,
                hover: false,
            };
        },

        props: {
            checkIn: {
                type: DateObject,
            },

            checkOut: {
                type: DateObject,
            },

            adults: {
                type: Number,
            },

            children: {
                type: Number,
            },

            inquireType: {
                type: String,
            },
        },

        computed: {
            bgCssClass() {
                if (this.hover) {
                    return 'border-primary';
                }
                return 'bg-light border-secondary';
            },
        },

        methods: {
            openModal() {
                this.modalOpen = true;
                this.showModal = true;
            },

            closeModal() {
                this.showModal = false;
                this.modalOpen = true;
            },

            onMouseEnter() {
                this.hover = true;
            },

            onMouseLeave() {
                this.hover = false;
            },
        }
    };

</script>
